import React, {useState} from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import ErrorAlert from 'lib/ui/alerts/ErrorAlert'
import SuccessAlert from 'lib/ui/alerts/SuccessAlert'
import {Area} from 'organization/Event/AreasProvider'
import Menu from 'lib/ui/Menu'
import ExportAttendeesSummaryMenuItem from './ExportAttendeesSummaryMenuItem'
import ExportAttendeesDetailedMenuItem from './ExportAttendeesDetailedMenuItem'
import ExportRoomAssignmentsMenuItem from './ExportRoomAssignmentsMenuItem'

export default function ExportAreaAttendees(props: {area: Area}) {
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)

  return (
    <>
      <ErrorAlert>{error}</ErrorAlert>
      <SuccessAlert>{success}</SuccessAlert>
      <Box mb={2}>
        <Menu
          button={({open}) => (
            <Button
              color="primary"
              variant="outlined"
              aria-label="export log"
              onClick={open}
            >
              Export Log
            </Button>
          )}
        >
          <ExportAttendeesSummaryMenuItem
            area={props.area}
            setError={setError}
            setSuccess={setSuccess}
          />
          <ExportAttendeesDetailedMenuItem
            area={props.area}
            setError={setError}
            setSuccess={setSuccess}
          />
          <ExportRoomAssignmentsMenuItem
            area={props.area}
            setError={setError}
            setSuccess={setSuccess}
          />
        </Menu>
      </Box>
    </>
  )
}
